import { NationalityCountryModel } from '@marketplace-web/nationality-select/nationality-select-data'

import {
  PepDetailsModel,
  PepType,
} from '@marketplace-web/pay-identity/politically-exposed-person-data'

import type { FormData } from './types'

export const getIsPersonalIdNumberFieldRequired = (
  personalIdNumberRequiredNationalities?: Array<string> | null,
  selectedNationality?: NationalityCountryModel | null,
) =>
  personalIdNumberRequiredNationalities?.some(
    nationality => nationality.toLowerCase() === selectedNationality?.code.toLowerCase(),
  ) || false

export const mapPepDetails = ({
  pepType,
  pepFullName,
  pepPosition,
  pepOrganisation,
  pepPositionDate,
}: Partial<FormData>): PepDetailsModel | undefined => {
  if (!pepType) return undefined

  switch (pepType) {
    case PepType.NotPep:
      return {
        type: pepType,
      }
    case PepType.Pep:
      return {
        type: pepType,
        organisation: pepOrganisation,
        position: pepPosition,
        holdsPositionFrom: pepPositionDate,
      }
    case PepType.PepAssociate:
      return {
        type: pepType,
        associatedPepFullName: pepFullName,
        organisation: pepOrganisation,
        position: pepPosition,
        holdsPositionFrom: pepPositionDate,
      }
    default:
      return undefined
  }
}

export const toBase64 = ({ file, removeMetadata }: { file: File; removeMetadata?: boolean }) =>
  new Promise<string | undefined>((resolve, reject) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)
    reader.onload = () => {
      let result = reader.result?.toString()

      if (removeMetadata) {
        result = result?.replace(/^.+(;base64),/, '')
      }

      resolve(result)
    }
    reader.onerror = error => reject(error)
  })

// modified version of lodash 'snakeCase' function
// - doesn't change dots with underscores
// - doesn't add underscores before numbers
export const snakeCase = (field: string) =>
  field
    .replace(/[^A-Za-z0-9.]/g, '_')
    .replace(/(\d+(?=[A-Za-z])|[a-z](?=[A-Z])|[A-Z]+(?=[A-Z][a-z]))/g, '$1_')
    .replace(/__+/g, '_')
    .replace(/(^_|_$)/g, '')
    .toLowerCase()
